var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input aggregationTable",
      class: _vm.input.extraClass,
      attrs: { type: "table" },
    },
    [
      _c("div", { staticClass: "input search" }, [
        _c("label", [
          _c("input", {
            attrs: { type: "search", placeholder: _vm.input.searchPlaceholder },
            on: {
              keyup: function ($event) {
                return _vm.searchTable($event)
              },
              blur: function ($event) {
                return _vm.searchTable($event)
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "tables", staticClass: "studies" },
        _vm._l(_vm.getTables, function (table) {
          return _c("div", [
            _c("header", [
              _vm._v(_vm._s(table.name) + " › " + _vm._s(table.versionName)),
            ]),
            _vm._v(" "),
            _c("table", [
              _c("thead", [
                _c(
                  "tr",
                  [
                    _c("td"),
                    _vm._v(" "),
                    _vm._l(_vm.input.forms, function (col) {
                      return _c("td", [_vm._v(_vm._s(col.name))])
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.getRows(_vm.input, table), function (row) {
                  return _c(
                    "tr",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.onStudyRowClick(row, _vm.input, table)
                        },
                      },
                    },
                    [
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.formValue.selectedRows,
                              expression: "formValue.selectedRows",
                            },
                          ],
                          attrs: {
                            type: "checkbox",
                            disabled: _vm.isDisabled(),
                          },
                          domProps: {
                            value: row.id,
                            checked: Array.isArray(_vm.formValue.selectedRows)
                              ? _vm._i(_vm.formValue.selectedRows, row.id) > -1
                              : _vm.formValue.selectedRows,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.formValue.selectedRows,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = row.id,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.formValue,
                                      "selectedRows",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.formValue,
                                      "selectedRows",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.formValue, "selectedRows", $$c)
                              }
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.input.forms, function (td) {
                        return _c(
                          "td",
                          [
                            typeof td.value === "string"
                              ? [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.getNestedValue(row, td.value)
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              : [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(td.value(table.data, row)) +
                                      "\n                            "
                                  ),
                                ],
                          ],
                          2
                        )
                      }),
                    ],
                    2
                  )
                }),
                0
              ),
            ]),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }